<template>
  <div class="va-row">
    <div class="flex md12">
      <vuestic-widget :headerText="'customer.create_field_title' | translate">
        <form @submit.prevent="addField">
          <div class="va-row">
            <div class="flex md6">
              <div class="form-group">
                <div class="input-group">
                  <select
                    id="field_type"
                    name="field_type"
                    required
                    v-model="type"
                  >
                    <option disabled selected>Select from list</option>
                    <option
                      v-for="(option, index) in typeOptions"
                      v-bind:key="index"
                      :value="option.type"
                      >{{ option.type }}</option
                    >
                  </select>
                  <label class="control-label" for="field_type">{{
                    'customer.fields.field_type' | translate
                  }}</label>
                  <i class="bar"></i>
                </div>
              </div>
            </div>
            <div class="flex md6">
              <div class="form-group">
                <div class="input-group">
                  <input id="field-title" required v-model="title" />
                  <label class="control-label" for="field-title">{{
                    'customer.fields.field_title' | translate
                  }}</label>
                  <i class="bar"></i>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="va-row" v-if="type.id !== 4">
            <div class="flex md6">
              <div class="form-group">
                <div class="input-group">
                  <input id="field-title" required v-model="placeholder">
                  <label
                    class="control-label"
                    for="field-title"
                  >{{'customer.fields.placeholder'| translate}}</label>
                  <i class="bar"></i>
                </div>
              </div>
            </div>
          </div>-->
          <div class="va-row" v-if="type.id === 3 || type.id === 5">
            <div
              v-for="(option, index) in options"
              v-bind:key="index"
              class="flex md6"
            >
              <div class="form-group">
                <div class="input-group">
                  <input
                    :id="'option-' + index"
                    required
                    v-model="options[index]"
                  />
                  <label class="control-label" :for="'option-' + index"
                    >{{ 'customer.fields.option' | translate
                    }}{{ index + 1 }}</label
                  >
                  <i class="bar"></i>
                </div>
              </div>
            </div>
            <div class="flex md6" v-if="type.id === 3">
              <button
                class="btn btn-secondary btn-sm"
                @click="addOption"
                type="button"
              >
                <div class="btn-with-icon-content">
                  <i class="ion-md-add ion"></i>
                  {{ 'customer.fields.add_option' | translate }}
                </div>
              </button>
              <button
                class="btn btn-danger btn-sm"
                @click="removeOption"
                type="button"
                v-if="options.length > 1"
              >
                <div class="btn-with-icon-content">
                  <i class="ion-md-remove ion"></i>
                  {{ 'customer.fields.remove_option' | translate }}
                </div>
              </button>
            </div>
          </div>
          <div class="va-row">
            <div class="flex md6 align--center justify--center">
              <label class="form-label">{{
                'customer.fields.required' | translate
              }}</label>
              <vuestic-switch v-model="required">
                <span slot="trueTitle">{{
                  'customer.fields.yes' | translate
                }}</span>
                <span slot="falseTitle">{{
                  'customer.fields.no' | translate
                }}</span>
              </vuestic-switch>
            </div>
            <div class="flex md6" v-if="type.id === 3">
              <label class="form-label">{{
                'customer.fields.selectType' | translate
              }}</label>
              <vuestic-switch v-model="selectType">
                <span slot="trueTitle">{{
                  'customer.fields.single' | translate
                }}</span>
                <span slot="falseTitle">{{
                  'customer.fields.multiple' | translate
                }}</span>
              </vuestic-switch>
            </div>
          </div>
          <div class="va-row justify--center">
            <button class="btn btn-primary btn-with-icon">
              <div class="btn-with-icon-content">
                <i class="ion-md-add ion"></i>
                {{ 'buttons.create' | translate }}
              </div>
            </button>
          </div>
        </form>
      </vuestic-widget>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CreateField',
  data() {
    return {
      typeOptions: [
        {
          id: 1,
          type: 'Text',
          needs_values: false
        },
        {
          id: 2,
          type: 'Textarea',
          needs_values: false
        },
        {
          id: 3,
          type: 'Select',
          needs_values: true
        },
        // {
        //   id: 4,
        //   type: "Checkbox"
        // },
        {
          id: 5,
          type: 'Radio',
          needs_values: true
        }
      ],
      options: ['', ''],
      type: '',
      title: '',
      placeholder: '',
      required: false,
      selectType: true,
      requestObject: {}
    }
  },
  methods: {
    addOption() {
      this.options.push('')
    },
    removeOption() {
      if (this.options.length > 1) {
        this.options.pop()
      }
    },
    addField() {
      this.requestObject.name = this.title
        .toLowerCase()
        .split(' ')
        .join('_')
      this.requestObject.needs_values = this.type.needs_values
      this.requestObject.field_type_id = this.type.id
      this.requestObject.is_required = this.required
      this.requestObject.field_title = this.title
      this.requestObject.placeholder = this.placeholder
      const values = this.options.map((option, index) => {
        return {
          option: {
            id: index,
            value: option
          }
        }
      })
      this.requestObject.values = values
      this.requestObject.selectType = !this.selectType
      this.$store
        .dispatch('createCustomerField', this.requestObject)
        .then(() => {
          this.$toasted.show('Customer Field Added', {
            icon: 'fa-star-o',
            position: 'top-right',
            duration: 5000,
            fullWidth: false
          })
          this.$router.push({ path: 'dashboard' })
        })
        .catch(() => {
          this.$toasted.show('Something Went Wrong', {
            icon: 'fa-star-o',
            position: 'top-right',
            duration: 5000,
            fullWidth: false
          })
        })
    }
  },
  created() {
    this.$nextTick(() => {
      this.$validator.validateAll()
    })
  }
}
</script>
